module.exports = __webpack_public_path__ + "img/PerceptionCarolina14.046e3e1b.jpg";